import template from './menu.tc-mobile-top-menu.html';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.paged-document.menu.menu.tc-mobile-top-menu',
    []
  )
  .component('tcMobileTopMenu', {
    //tc-mobile-top-menu
    template,
    bindings: {
      document: '<',
    },
    controller: function ($rootScope) {
      this.$onInit = () => {
        // Ensure document and metadata are available before accessing them
        if (!this.document || !this.document.metadata || !this.document.metadata.pages) {
          console.warn('TcMobileTopMenu: document, metadata, or pages not available');
          return;
        }

        this.currentIndex = 0;
        this.pages = this.document.metadata.pages;
        this.lastPageIndex = this.pages.length - 1;
      };

      this.onClose = () => {
        $rootScope.$emit('tcDocument:close');
      };

      this.showMenu = false;
      this.toggleMenu = () => {
        this.showMenu = !this.showMenu;
      };

      this.getPageTitle = (page, index) => {
        return (
          page.elements[0].title ||
          page.elements[0].text ||
          'Page ' + (index + 1)
        );
      };

      const cleanMenuSetUpListener = $rootScope.$on(
        'tcDocument:menu:set',
        (_event, index) => {
          this.currentIndex = index;
        }
      );

      this.$onDestroy = () => {
        cleanMenuSetUpListener();
      };
    },
  }).name;
